import React from 'react'

const registerpage = () => {
  return (
    <div>registerpage</div>
  )
}

export default registerpage